// component imports
import { Component, ChangeDetectionStrategy, Input, Inject } from '@angular/core';
import { CONSTANTS } from '../../../constants/constants';

@Component({
    selector: 'app-olci-prompts-inner',
    templateUrl: './olci-prompts-inner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OlciPromptsInnerComponent {
	@Input() public layoutState: any;
	@Input() public bundle: any;
	@Input() public screensize: any;

	constructor(@Inject(CONSTANTS) private readonly constants: any) {}
}
